import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskCompleteLatePage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskCompleteLatePage;
